import React from 'react';
import PropTypes from 'prop-types';
import AppsContainer from '@tenant/core/AppsContainer';
import clsx from 'clsx';
import AppsHeader from '@tenant/core/AppsContainer/AppsHeader';
import { Box } from '@mui/material';
import FooterWrapper from '@tenant/core/AppLayout/components/AppFooter/FooterWrapper';

const ROW_HEIGHT = 52;
const OFFSET_ROW_HEIGHT = 70;
const MIN_ROW_HEIGHT = 125;

const ListLayout = ({
  rows = 0,
  title,
  table,
  detail,
  appHeader,
  appFooter,
  isShowDetail = false,
  children,
}) => {
  return (
    <AppsContainer
      fullView
      title={title}
      sxStyle={{ '& .app-container__content': { height: 'auto !important' } }}
    >
      <Box
        sx={{
          visibility: !isShowDetail ? 'visible' : 'hidden',
          '& .MuiDataGrid-root': {
            borderLeft: 0,
            borderRight: 0,
            borderTop: 0,
            borderRadius: 0,
          },
        }}
      >
        {!!appHeader && <AppsHeader>{appHeader}</AppsHeader>}

        <Box
          sx={{
            height: !isShowDetail
              ? Math.max(MIN_ROW_HEIGHT, rows * ROW_HEIGHT + OFFSET_ROW_HEIGHT)
              : 'calc(100vh - 300px)',
            borderBottom: '1px solid #ddd',
            '& .MuiDataGrid-root': {
              borderBottom: 0,

              '& .MuiDataGrid-row:last-child .MuiDataGrid-cell': {
                borderBottom: 0,
              },
            },
          }}
        >
          {table ?? children}
        </Box>

        {!!appFooter && <FooterWrapper>{appFooter}</FooterWrapper>}
      </Box>

      <Box
        sx={{
          transition: 'all 0.5s ease',
          transform: 'translateX(100%)',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1,
          opacity: 0,
          visibility: 'hidden',
          backgroundColor: 'background.paper',
          '&.show': {
            transform: 'translateX(0)',
            opacity: 1,
            visibility: 'visible',
          },
        }}
        className={clsx({
          show: isShowDetail,
        })}
      >
        {detail}
      </Box>
    </AppsContainer>
  );
};

export default React.memo(ListLayout);

ListLayout.propTypes = {
  title: PropTypes.node,
  table: PropTypes.node,
  detail: PropTypes.node,
  appHeader: PropTypes.node,
  appFooter: PropTypes.node,
  isShowDetail: PropTypes.bool,
  rows: PropTypes.number,
  children: PropTypes.node,
};
